import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const LogLink = styled(Link)`
  color: ${({ theme }) => theme.primary[600]};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
